export default __webpack_public_path__ + "static/media/skovstykket-tenancy-06.9f9cb8e9.jpg";